import React from "react"
import ReactExport from "react-export-excel"
import _ from "lodash"
import "./excel.scss"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class ExcelDownload extends React.Component {

    state = {
        data:[],
        headerData:[],
        excelData:[],
        sheaderData:[]
    }
    
  componentWillMount(){
    this.props.Excel()
  }  
    
  componentDidUpdate(prevProps){
      let arr 
      if(this.props){
      if(this.props.props && prevProps.props.revenues !== this.props.props.revenues &&prevProps.props.spending !== this.props.props.spending ){ 
      if(this.props.show === "admin" && this.props.props.spending.length && this.props.props.revenues.length ){
        arr =[{name:"Recettes",data:this.props.props.revenues},{name:"Dépenses",data:this.props.props.spending}]
      }else if( this.props.props.spending.length && this.props.props.synthesis.length && this.props.props.revenues.length){
        arr =[{name:"Recettes",data:this.props.props.revenues},{name:"Dépenses",data:this.props.props.spending},{name:"Synthèse",data:this.props.props.synthesis}]
      } 

      let mainExcel = []
      arr && arr.map(rr => {
        let headers = []
        let sheaders = []
        if (this.props.show === "admin"){
             headers = ["Numéro compte", ...this.props.props.head] 
             sheaders = [...this.props.props.head]
          }
          if(this.props.show === "detail") {
                 headers =["Numéro compte", ...this.props.props.headers] 
                 sheaders =[...this.props.props.headers]     
          }

          this.setState({headerData:headers,sheaderData:sheaders})
        const data = rr.data 
        let rLastData = [] 
        let spLastData = []
        let syLastData = []
        data && data.forEach((res, i) => {
            if (rr.name === "Recettes") {
                this.props.props.revenuesTableDef.rows.forEach((s,index)=>{
                    if (i === index) {
                        if (res[0] === "Total") {
                                rLastData.push(["", ...res])   
                          } else {
                            if (rr.name === "Recettes") {
                                // let firstItem = res[0]
                                // let remove = res.splice(0, 1)
                                // let amount = s.amount || s.amount == 0 ? `${s.amount}%` : ''
                                // let changeFirstItem = `${firstItem}${'  '}${amount}`
                                // let changes= [changeFirstItem,...remove]
                                let data = s && s.account ? [s.account.number, ...res] : s.chapter ? [s.chapter.number, ...res] : ['', ...res] 
                                rLastData.push(data) 
                            } 
                     }
                    }
                })
            } 
            if (rr.name === "Dépenses") {
                this.props.props.spendingTableDef.rows.forEach((s,index) => {
                    if (i === index) {
                        if (res[0] === "Total") {
                               spLastData.push(["", ...res])   
                          } else {
                            if (rr.name === "Dépenses") {
                                // let firstItem = res[0]
                                // let amount = s.amount || s.amount == 0 ? `${s.amount}%` : ''
                                // let changeFirstItem = `${firstItem}${'  '}${amount}`
                                // let changes= [changeFirstItem,...remove]
                                let data = s && s.account ? [s.account.number, ...res] : s.chapter ? [s.chapter.number, ...res] : ['', ...res] 
                                spLastData.push(data) 
                            }
                     }
                    }
                })
            }
            if (rr.name === "Synthèse") {
                syLastData.push([...res])
            } 
            
        })

        let table = rr.name === "Recettes" ? rLastData : rr.name === "Dépenses" ? spLastData : syLastData 

        let excel = []
        table.forEach((row, index) => {
            let singleRow = {}
            row && row.forEach((rowData, rowIndex) => {
                let headerName = rr.name !== "Synthèse" ? headers[rowIndex] && headers[rowIndex].toString() : sheaders[rowIndex] && sheaders[rowIndex].toString()
                if (this.props.show === "detail") {
                    if (typeof rowData === 'object') {
                        singleRow = {
                            ...singleRow,
                            [headerName]: rowData && rowData.value ? rowData && rowData.value : rowData && rowData.value == "0" ? '0' : '',
                        }
                    } else {
                        singleRow = {
                            ...singleRow,
                            [headerName]: rowData ? rowData : rowData == "0" ? '0' : '',
                        }
                    }
                } else {
                    if (typeof rowData === 'object') {
                        singleRow = {
                            ...singleRow,
                            [headerName]: rowData.amount ? rowData.amount : rowData.amount == "0" ? '0' : '',
                        }
                    } else {
                        singleRow = {
                            ...singleRow,
                            [headerName]: rowData ? rowData : rowData == "0" ? '0' : '',
                        } 
                    }
                }
            });
            excel=[...excel,singleRow];
        });
        mainExcel.push({name:rr.name,data:excel})  
        this.setState({excelData:mainExcel,data:[...this.state.data,data]})   
      })  
     
    }
   }
  }   

render(){
    return (
        <div>
            {this.state.excelData.length > 0 && this.props.show === "detail" &&
        <ExcelFile element={<button className='button'>Export vers Excel</button>}>
            <ExcelSheet data={this.state.excelData[0].data} name={this.state.excelData[0].name}>
            {this.state.headerData.map((res,i)=><ExcelColumn key={i} label={res} value={res} />)}
            </ExcelSheet>
            <ExcelSheet data={this.state.excelData[1].data} name={this.state.excelData[1].name}>
            {this.state.headerData.map((res,i)=><ExcelColumn key={i} label={res} value={res} />)}
            </ExcelSheet>
            <ExcelSheet data={this.state.excelData[2] && this.state.excelData[2].data} name={this.state.excelData[2] && this.state.excelData[2].name}>
            {this.state.sheaderData.map((res,i)=><ExcelColumn key={i} label={res} value={res} />)}
            </ExcelSheet> 
        </ExcelFile>}
        {this.state.excelData.length > 0 && this.props.show === "admin"&&
        <ExcelFile element={<button className='button'>Export vers Excel</button>}>
            <ExcelSheet data={this.state.excelData[0].data} name={this.state.excelData[0].name}>
            {this.state.headerData.map((res,i)=><ExcelColumn key={i} label={res} value={res} />)}
            </ExcelSheet>
            <ExcelSheet data={this.state.excelData[1].data} name={this.state.excelData[1].name}>
            {this.state.headerData.map((res,i)=><ExcelColumn key={i} label={res} value={res} />)}
            </ExcelSheet>
        </ExcelFile>}
        </div>
    );
}  
};

export default ExcelDownload;


// WEBPACK FOOTER //
// ./src/component/scenarii/excelfile.js